export class BookingDayView {

    id: string;
    date: Date;
    dayOfWeek: string;
    dateString: string;
    enabled: Boolean


    constructor(id: string, date: Date, dayOfWeek: string, dateString: string, enabled: Boolean) {
        this.id = id;
        this.date = date;
        this.dayOfWeek = dayOfWeek;
        this.dateString = dateString;
        this.enabled = enabled;
    }
}